<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'main.addRewards' | translate}}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close(updateFinished)"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content>
<div class="credit-correction">
  @if (usersStr) {
    <div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'frontUser.addCreditsForUsers' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="users-list">{{usersStr}}</div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }
  <div class="rewards-select">
    <mat-form-field>
      <mat-label>{{'main.eventType' | translate}}</mat-label>
      <mat-select [(value)]="selectedEventType" required>
        @for (event of eventCategories; track event) {
          <mat-option [value]="event.value" [style.color]="event.color">
            <span style="font-weight: bold">{{event.label}}</span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="rewards-input">
    <mat-form-field class="example-full-width">
      <mat-label>{{'Credits' | translate}}</mat-label>
      <input matInput value="0" type="number" [(ngModel)]="credits" required>
    </mat-form-field>
  </div>
  <div class="full-width">
    <mat-form-field class="full-width">
      <mat-label>{{'frontUser.comment' | translate}}</mat-label>
      <input matInput value="" type="text" [(ngModel)]="comment">
    </mat-form-field>
  </div>
  <div style="text-align: center">
    @if (!updateFinished) {
      <button mat-raised-button (click)="startCorrection()" [disabled]="!selectedEventType || !credits"
              class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'add_credits' | translate}}</span>
      </button>
    }
  </div>
  @if (updateFinished) {
    @if (!errorResult?.length) {
      <div class="success-result">{{'frontUser.allUserCreditsUpdated' | translate}} <mat-icon>check_circle_outline</mat-icon></div>
    } @else {
      <div class="results">
        @for (res of errorResult; track res; let i = $index) {
          <div class="result">
            <div class="name">{{i+1}}. {{res.user}}</div>
            <div class="msg">{{res}}</div>
            <div class="icon"><mat-icon style="color: red; font-weight: bold">highlight_off</mat-icon></div>
          </div>
        }
      </div>
    }
  }
</div>
  </div>
</div>
